<template>
  <div class="carrot">

    <div class="main-wrapper">
      <Menu></Menu>
      <PopAddressSearch :visible="isAddress" :address="program.location" @onSearch="addressSearch"
                        @close="addressClose"/>
      <CategorySearch :visible="isCategory" @close="categoryClose"
                      @pick="selectCategory"></CategorySearch>
      <Preview :visible="is_preview" @close="vue_close" :program="program"></Preview>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">교육 프로그램 수정</h3>
            </div>
          </div>
          <div class="row mt-20">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <p class="mb-10">교육 정보</p>
                  <div class="text-center">
                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <th><span class="red">*</span>&nbsp;카테고리</th>
                        <td>
                          <select v-model="program.idxCategory" class="form-control w-20per">
                            <option value="">카테고리 선택</option>
                            <option v-for="item in categories" :key="item.idx" :value="item.idx">
                              {{ item.name }}
                            </option>
                          </select>
                          <!--<button @click="isCategory = true" class="btn btn-dark fl">
                            {{
                              (this.program.category.name !== undefined)
                                  ? this.program.category.name : '카테고리를 선택해주세요'
                            }}
                          </button>-->
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>노출순서</th>
                        <td>
                          <input v-model.number="program.ordernum" type="number"
                                 class="form-control w-100per"/>
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>&nbsp;프로그램 명</th>
                        <td>
                          <input v-model="program.programName" type="text"
                                 class="form-control w-100per"/>
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>&nbsp;사용여부</th>
                        <td class="txt-left">
                          <label><input v-model="program.isUse" type="radio" value="Y">사용</label>
                          <label class="mt-1"><input v-model="program.isUse" type="radio" value="N">사용안함</label>
                          <!--<button @click="program.isUse = 'Y'" class="btn w-30 btn-dark " :class="{ 'disabled' : program.isUse === 'N'}"> 사용</button>
                          <button @click="program.isUse = 'N'" class="btn w-30 btn-dark ml-1" :class="{ 'disabled' : program.isUse === 'Y'}"> 사용안함</button>-->
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <span class="red">*</span> 썸네일
                          <p class="red">* jpg, png 등록 가능 <br>권장사이즈198*220 </p>
                        </th>
                        <td>
                          <upload-image :img-style="'width:198px; height:220px;'"
                                        :url="imageUrl + 'thum'" :img="program.thum"
                                        @mountImage="program.thum = $event"/>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <span class="red">*</span>&nbsp;상단이미지
                          <p class="red">* jpg, png 등록 가능 <br>권장사이즈412*245 </p>
                        </th>
                        <td>
                          <upload-image :img-style="'width:412px; height:245px;'"
                                        :url="imageUrl + 'upperImage'" :img="program.upperImage"
                                        @mountImage="program.upperImage = $event"/>
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>&nbsp;신청기간</th>
                        <td class="text-left">
                          <span>
                          <label><input type="radio" value="Y" v-model="program.isTime">사용</label>
                          <label class="ml-1"><input type="radio" value="N" v-model="program.isTime">사용안함</label>
                          </span>
                          <span class="pl-1">
                          <input type="date" v-model="program.applySdate"/>
                          ~ <input type="date" v-model="program.applyEdate"/>
                          </span>
                          <!--<input type="radio" value="N" v-model="program.isTime">-->
                          <!--<button @click="program.isTime = 'Y'" class="btn w-30 btn-dark " :class="{ 'disabled' : program.isTime === 'N'}"> 기간제한</button>
                          <button @click="program.isTime = 'N'" class="btn w-30 btn-dark ml-1" :class="{ 'disabled' : program.isTime === 'Y'}"> 제한없음</button>-->
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>&nbsp;교육기간</th>
                        <td>
                          <div class="fl clear">
                            <input type="date" v-model="program.sdate"/>
                            ~ <input type="date" v-model="program.edate"/>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>&nbsp;교육장소</th>
                        <td class="text-left clear">
                          <label class="w-100per">
                            <button class="btn btn-dark fl ml-1" @click="isAddress = true">주소검색
                            </button>
                            <input type="text" v-model="program.location"
                                   class="form-control w-90per fl">
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>&nbsp;모집인원</th>
                        <td class="text-left clear">
                          <label><input type="radio" v-model='program.isLimit'
                                        value="N">제한없음</label>
                          <span class="pl-1">
                            <label><input type="radio" v-model='program.isLimit'
                                          value="Y">선착순</label>
                            <input :disabled="program.isLimit === 'N'" v-model="program.maxCount"
                                   type="number" class="w-10"/> 명
                          </span>
                          <!--<button @click="program.isLimit = 'Y'" class="btn w-30 btn-dark " :class="{ 'disabled' : program.isLimit === 'N'}"> 인원제한</button>
                          <button @click="program.isLimit = 'N'" class="btn w-30 btn-dark ml-1" :class="{ 'disabled' : program.isLimit === 'Y'}"> 제한없음</button>-->
                        </td>
                      </tr>
                      <tr>
                        <th>내용</th>
                        <td class="text-left clear">
                          <ckeditor :editor="editor" v-model="program.content"
                                    :config="editorConfig"/>
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>&nbsp;유료여부</th>
                        <td class="txt-left">
                          <label><input type="radio" v-model="program.isFree" value="Y">무료</label>
                          <label class="ml-1"><input type="radio" v-model="program.isFree" value="N">유료</label>
                          <div v-if="program.isFree === 'N'">
                            <div v-if="policyLimit >= 1">
                              <input v-model="program.detail.policy1" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price1" type="number" placeholder="금액 입력"
                                     class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <div class="mt-10" v-if="policyLimit >= 2">
                              <input v-model="program.detail.policy2" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price2" type="number" placeholder="금액 입력"
                                     class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <div class="mt-10" v-if="policyLimit >= 3">
                              <input v-model="program.detail.policy3" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price3" type="number" placeholder="금액 입력"
                                     class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <div class="mt-10" v-if="policyLimit >= 4">
                              <input v-model="program.detail.policy4" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price4" type="number" placeholder="금액 입력"
                                     class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <div class="mt-10" v-if="policyLimit >= 5">
                              <input v-model="program.detail.policy5" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price5" type="number" placeholder="금액 입력"
                                     class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <div class="mt-10" v-if="policyLimit >= 6">
                              <input v-model="program.detail.policy6" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price6" type="number" placeholder="금액 입력"
                                     class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <div class="mt-10" v-if="policyLimit >= 7">
                              <input v-model="program.detail.policy7" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price7" type="number" placeholder="금액 입력"
                                     class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <div class="mt-10" v-if="policyLimit >= 8">
                              <input v-model="program.detail.policy8" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price8" type="number" placeholder="금액 입력"
                                     class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <div class="mt-10" v-if="policyLimit >= 9">
                              <input v-model="program.detail.policy9" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price9" type="number" placeholder="금액 입력"
                                     class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <div class="mt-10" v-if="policyLimit >= 10">
                              <input v-model="program.detail.policy10" type="text"
                                     class="" placeholder="상품명 입력"/>
                              <input v-model="program.detail.price10" type="number"
                                     placeholder="금액 입력" class="ml-1 text-right"/> 원
                              <label class="ds-inline"></label>&nbsp;
                            </div>
                            <button @click="addPolicy()" class="btn btn-dark mt-10">+ 상품 추가</button>
                            <button @click="removePolicy()" class="btn btn-dark mt-10 ml-1">- 상품 삭제</button>
                          </div>
                          <!--<button @click="program.isFree = 'Y'" class="btn w-30 btn-dark "
                                  :class="{ 'disabled' : program.isFree === 'N'}"> 무료
                          </button>
                          <button @click="program.isFree = 'N'" class="btn w-30 btn-dark ml-1"
                                  :class="{ 'disabled' : program.isFree === 'Y'}"> 유료
                          </button>-->
                        </td>
                      </tr>
                      <tr>
                        <th>입력정보</th>
                        <td class="txt-left">
                          <div v-if="questionLimit >= 1">
                            <input v-model="program.detail.question1" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder1" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer1" type="checkbox" true-value="Y" false-value="N">
                          </div>
                          <div class="mt-10" v-if="questionLimit >= 2">
                            <input v-model="program.detail.question2" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder2" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer2" type="checkbox" true-value="Y" false-value="N">
                          </div>
                          <div class="mt-10" v-if="questionLimit >= 3">
                            <input v-model="program.detail.question3" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder3" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer3" type="checkbox" true-value="Y" false-value="N">
                          </div>
                          <div class="mt-10" v-if="questionLimit >= 4">
                            <input v-model="program.detail.question4" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder4" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer4" type="checkbox" true-value="Y" false-value="N">
                          </div>
                          <div class="mt-10" v-if="questionLimit >= 5">
                            <input v-model="program.detail.question5" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder5" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer5" type="checkbox" true-value="Y" false-value="N">
                          </div>
                          <div class="mt-10" v-if="questionLimit >= 6">
                            <input v-model="program.detail.question6" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder6" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer6" type="checkbox" true-value="Y" false-value="N">
                          </div>
                          <div class="mt-10" v-if="questionLimit >= 7">
                            <input v-model="program.detail.question7" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder7" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer7" type="checkbox" true-value="Y" false-value="N">
                          </div>
                          <div class="mt-10" v-if="questionLimit >= 8">
                            <input v-model="program.detail.question8" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder8" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer8" type="checkbox" true-value="Y" false-value="N">
                          </div>
                          <div class="mt-10" v-if="questionLimit >= 9">
                            <input v-model="program.detail.question9" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder9" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer9" type="checkbox" true-value="Y" false-value="N" value="N">
                          </div>
                          <div class="mt-10" v-if="questionLimit >= 10">
                            <input v-model="program.detail.question10" type="text"
                                   placeholder="옵션 입력 "
                                   class=""/>
                            <input v-model="program.detail.placeholder10" type="text"
                                   placeholder="안내문구 입력"
                                   class="ml-1 w-30per"/>
                            필수 <input v-model="program.detail.needanswer10" type="checkbox" true-value="Y" false-value="N" value="N">
                          </div>

                          <button @click="addQuestion()" class="btn btn-dark mt-10">+ 옵션 추가</button>
                          <button @click="removeQuestion()" class="btn btn-dark mt-10 ml-1">- 옵션 삭제</button>
                        </td>
                      </tr>
                      </thead>
                    </table>
                  </div>

                  <div class="clear mt-20">
                    <button @click="$router.push('/program')" type="submit"
                            class="btn btn-primary fl">목록
                    </button>
                    <button @click="deleteProgram()" type="submit" class="btn btn-danger fl ml-10">
                      삭제
                    </button>
                    <button @click="putProgram()" type="submit" class="btn btn-primary fr ml-10">
                      저장
                    </button>
                    <button type="submit" class="btn btn-primary fr" @click="showPreview()">미리보기
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from '../../components/inc_menu.vue'
import Preview from "../../components/preview/pop_preview_program.vue";
import CategorySearch from '@/components/popCategorySearch';
import PopAddressSearch from '../../components/popAddressSearch';
import UploadImage from '../../components/uploadImage';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import router from "@/router";

export default {
  name: 'ProgramModify',
  components: {
    Menu,
    Preview,
    CategorySearch,
    PopAddressSearch,
    UploadImage
  },
  props: {
    msg: String
  },

  data: () => ({
    categories: [],

    ///component
    is_preview: false,
    isCategory: false,
    isAddress: false,
    isThum: false,
    isUpper: false,

    ///limit
    questionLimit: 1,
    policyLimit: 1,

    ///editor
    editor: ClassicEditor,
    editorData: '',
    editorConfig: {
      // The configuration of the editor.
      filebrowserUploadUrl: 'https://stage-platform-api.carrotenglish.net/v1/admin/editor',
      ckfinder: {
        uploadUrl: 'https://stage-platform-api.carrotenglish.net/v1/admin/editor'
      }
    },

    ///program
    category: {},
    program: {
      idx: 0,
      idxCategory: '',
      categoryName: "",
      ordernum: 1,
      currentCount: 0,
      maxCount: 0,
      programName: "",
      content: "",
      thum: "",
      upperImage: "",
      location: "",
      week: "",
      isUse: "Y",
      isTime: "Y",
      isFree: "N",
      isLimit: "Y",
      applySdate: "",
      applyEdate: "",
      sdate: "",
      edate: "",
      createDate: "",
      updateDate: "",
      detail: {
        policy1: null,
        policy2: null,
        policy3: null,
        policy4: null,
        policy5: null,
        policy6: null,
        policy7: null,
        policy8: null,
        policy9: null,
        policy10: null,
        price1: null,
        price2: null,
        price3: null,
        price4: null,
        price5: null,
        price6: null,
        price7: null,
        price8: null,
        price9: null,
        price10: null,
        question1: null,
        question2: null,
        question3: null,
        question4: null,
        question5: null,
        question6: null,
        question7: null,
        question8: null,
        question9: null,
        question10: null,
        placeholder1: null,
        placeholder2: null,
        placeholder3: null,
        placeholder4: null,
        placeholder5: null,
        placeholder6: null,
        placeholder7: null,
        placeholder8: null,
        placeholder9: null,
        placeholder10: null
      },
      category: {},
    },

    ///search
    filter: {
      page: 1,
      status: '',
      isUse: 'Y',
    },

  }),
  computed: {
    needAnswer: function (value){
      return (value === 'Y') ? 'Y' : 'N';
    },

    imageUrl: function () {
      return this.$store.state.host + "/v1/admin/programs/image/";
    },
  },
  mounted() {
    this.initPage();
  },
  methods: {
    showPreview: function () {
      this.is_preview = true;
    },
    vue_close: function (state) {
      this.is_preview = state;
    },
    initPage: function () {
      this.getProgram();
      this.getCategories();
    },

    ///policy&question
    addPolicy: function () {
      if (this.policyLimit <= 10) {
        this.policyLimit++;
      } else {
        alert("추가 가능한 가격정보를 초과했습니다.")
      }
    },
    removePolicy: function () {
      if (this.policyLimit > 1) {
        this.program.detail['price' + this.policyLimit] = null;
        this.program.detail['policy' + this.policyLimit] = null;
        this.policyLimit--;
      } else {
        alert("더이상 삭제할 가격정보가 없습니다.")
      }
    },
    addQuestion: function () {
      if (this.questionLimit <= 10) {
        this.questionLimit++;
      } else {
        alert("추가 가능한 입력정보를 초과했습니다.")
      }
    },

    ///address
    addressSearch: function (result) {
      this.program.location = result.address;
    },
    addressClose: function () {
      this.isAddress = false;
    },

    removeQuestion: function () {
      if (this.questionLimit > 1) {
        this.program.detail['placeholder' + this.questionLimit] = null;
        this.program.detail['question' + this.questionLimit] = null;
        this.program.detail['needanswer' + this.questionLimit] = 'N';
        this.questionLimit--;
      } else {
        alert("더이상 삭제할 입력정보가 없습니다.")
      }
    },

    getProgram: function () {
      const url = this.$store.state.host + "/v1/admin/programs/" + this.$route.params.idx;
      this.axios.get(url)
      .then((res) => {
        var data = res.data;
        if (data.status === 0) {
          this.program = res.data.result;
          if (this.program.detail == null) {
            this.program.detail = {
              policy1: null,
              policy2: null,
              policy3: null,
              policy4: null,
              policy5: null,
              policy6: null,
              policy7: null,
              policy8: null,
              policy9: null,
              policy10: null,
              price1: null,
              price2: null,
              price3: null,
              price4: null,
              price5: null,
              price6: null,
              price7: null,
              price8: null,
              price9: null,
              price10: null,
              question1: null,
              question2: null,
              question3: null,
              question4: null,
              question5: null,
              question6: null,
              question7: null,
              question8: null,
              question9: null,
              question10: null,
              placeholder1: null,
              placeholder2: null,
              placeholder3: null,
              placeholder4: null,
              placeholder5: null,
              placeholder6: null,
              placeholder7: null,
              placeholder8: null,
              placeholder9: null,
              placeholder10: null
            };
          }
          /// 프로그램 세부사항 처리
          if (this.program.detail.question1 != null) {
            this.questionLimit = 1;
          }
          if (this.program.detail.question2 != null) {
            this.questionLimit = 2;
          }
          if (this.program.detail.question3 != null) {
            this.questionLimit = 3;
          }
          if (this.program.detail.question4 != null) {
            this.questionLimit = 4;
          }
          if (this.program.detail.question5 != null) {
            this.questionLimit = 5;
          }
          if (this.program.detail.question6 != null) {
            this.questionLimit = 6;
          }
          if (this.program.detail.question7 != null) {
            this.questionLimit = 7;
          }
          if (this.program.detail.question8 != null) {
            this.questionLimit = 8;
          }
          if (this.program.detail.question9 != null) {
            this.questionLimit = 9;
          }
          if (this.program.detail.question10 != null) {
            this.questionLimit = 10;
          }

          if (this.program.detail.policy1 != null) {
            this.policyLimit = 1;
          }
          if (this.program.detail.policy2 != null) {
            this.policyLimit = 2;
          }
          if (this.program.detail.policy3 != null) {
            this.policyLimit = 3;
          }
          if (this.program.detail.policy4 != null) {
            this.policyLimit = 4;
          }
          if (this.program.detail.policy5 != null) {
            this.policyLimit = 5;
          }
          if (this.program.detail.policy6 != null) {
            this.policyLimit = 6;
          }
          if (this.program.detail.policy7 != null) {
            this.policyLimit = 7;
          }
          if (this.program.detail.policy8 != null) {
            this.policyLimit = 8;
          }
          if (this.program.detail.policy9 != null) {
            this.policyLimit = 9;
          }
          if (this.program.detail.policy10 != null) {
            this.policyLimit = 10;
          }

        } else {
          alert(data.result);
          router.push('/program');
        }
      });
    },

    putProgram: function () {
      const url = this.$store.state.host + "/v1/admin/programs/" + this.$route.params.idx;
      ///validation
      if (this.program.idxCategory === "") {
        alert("프로그램 카테고리를 선택 해주세요.")
      } else if (this.program.ordernum === "") {
        alert("프로그램 노출순서를 입력 해주세요.")
      } else if (this.program.programName === "") {
        alert("프로그램 제목을 입력 해주세요.")
      } else if (this.program.thum === "") {
        alert("프로그램 썸네일을 업로드 해주세요.")
      } else if (this.program.upperImage === "") {
        alert("프로그램 상단이미지를 업로드 해주세요.")
      } else if (this.program.isTime === "Y" && (this.program.applySdate === null
          || this.program.applyEdate === null)) {
        alert("프로그램 신청기간를 입력해주세요.")
      } else if (this.program.sdate === null || this.program.edate === null) {
        alert("프로그램 교육기간를 입력해주세요.")
      } else if (this.program.isLimit === "Y" && this.program.maxCount <= 0) {
        alert("프로그램 모집인원을 입력해주세요.")
      } else {
        this.axios.put(url, this.program)
        .then((res) => {
          if (res.data.status === 0) {
            alert("프로그램 수정이 완료되었습니다.")
            this.$router.push('/program')
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          alert(err);
        })
      }
    },

    deleteProgram: function () {
      if (confirm('삭제 하시겠습니까?')) {
        const url = this.$store.state.host + "/v1/admin/programs/" + this.$route.params.idx;
        this.axios.delete(url)
        .then(function (res) {
          if (res.data.status === 0) {
            alert(res.data.result);
            router.push('/program')
          } else {
            alert(res.data.result);
          }
        });
      }
    },

    postProgramImage: function () {
      let formData = new FormData();
      formData.append('file', this.$refs.thum.files[0]);

      const url = this.$store.state.host + "/v1/admin/programs/image/" + "thum";
      this.isThum = true;
      this.axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}})
      .then((res) => {
        this.isThum = false;
        this.program.thum = res.data.result;
      })
      .catch((err) => {
        this.isThum = false;
        alert(err)
      })
    },

    postProgramUpperImage: function () {
      let formData = new FormData();
      formData.append('file', this.$refs.upper.files[0]);

      const url = this.$store.state.host + "/v1/admin/programs/image/" + "upperImage";
      this.isUpper = true;
      this.axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}})
      .then((res) => {
        this.isUpper = false;
        this.program.upperImage = res.data.result;
      })
      .catch((err) => {
        this.isUpper = false;
        alert(err);
      })
    },

    getCategories: function () {
      this.axios.get(this.$store.state.host + "/v1/admin/programs/category")
      .then((res) => {
        this.categories = res.data.result;
      });
    },
    selectCategory: function (category) {
      this.program.category = category
      this.program.idxCategory = category.idx
    },
    categoryClose: function () {
      this.isCategory = false;
    },

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
/* Tables */
</style>
